import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { tap } from 'rxjs/operators';
import { Api } from 'src/app/shared/constants/api';
import { PermissionKey } from 'src/app/shared/constants/permissionCode';
import { IPermissionWithShow } from 'src/app/shared/interface';
import { DataService } from 'src/app/shared/services/data.service';
import { PermissionService } from 'src/app/shared/services/permissions.service';
import * as _ from 'underscore';
import { IVertical, IVerticalCriteria } from '../vertical.interface';


@Component({
    selector: 'app-vertical-list',
    templateUrl: './vertical-list.component.html',
    styleUrls: ['./vertical-list.component.less'],
    standalone: false
})
export class VerticalListComponent implements OnInit,AfterViewInit {

  constructor(private service:DataService,private logger:NGXLogger,
              private formBuilder:FormBuilder,private router:Router,
              private activatedRoute:ActivatedRoute,private permissionService:PermissionService) { }
  addPermission:boolean = false;
  viewPermission:boolean = false;
  verticalListForm:FormGroup;
  verticalDataSource=new MatTableDataSource<IVertical>();
  verticalColumns=['code','name','alias','status','action'];
  criteria:IVerticalCriteria={};
  totalRecords:any;
  statusTypes:any;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  ngOnInit(): void {
    this.getAllPermissions();
    this.initializeForm();
    this.getStatusTypes();
    this.setCodeValueChangeEvent();
    this.setNameValueChangeEvent();
    this.setStatusValueChangeEvent();
    this.setAliasValueChangeEvent();
  }

  sortData(event: { active: string; direction: string; }){
		this.criteria.sort = [event.active, event.direction];
		this.getVerticalList();
	}

  ngAfterViewInit(){
    this.verticalDataSource.sort=this.sort;
    this.verticalDataSource.paginator=this.paginator;
    this.paginator?.page.pipe(tap(() => this.getVerticalList())).subscribe();
    this.getVerticalList();
  }

  private initializeForm() {
    this.verticalListForm=this.formBuilder.group({
      id:[],
      name:[],
      code:[],
      status:[],
      aliasName:[]
    });
  }

  private setCodeValueChangeEvent(){
    this.code.valueChanges.subscribe(codeValue => {
      this.criteria['code.contains']=codeValue;
      this.getVerticalList();
    })
  }

  private setNameValueChangeEvent(){
    this.name.valueChanges.subscribe(nameValue => {
      this.criteria['name.contains']=nameValue;
      this.getVerticalList();
    })
  }

  private setStatusValueChangeEvent(){
    this.status.valueChanges.subscribe(statusValue => {
      this.criteria.status=statusValue;
      this.getVerticalList();
    })
  }

  private setAliasValueChangeEvent(){
    this.aliasName.valueChanges.subscribe(aliasValue => {
      this.criteria.aliasName=aliasValue;
      this.getVerticalList();
    })
  }

  openForm(id?:number){
    if(id){
      this.router.navigate(['edit/'+id],{relativeTo:this.activatedRoute});
    } else {
      this.router.navigate(['add'],{relativeTo:this.activatedRoute});
    }
 }

  private getVerticalList(){
    this.criteria.size=this.paginator?.pageSize;
    this.criteria.page=this.paginator?.pageIndex;
    this.service.get(Api.VERTICAL,this.criteria).subscribe(res => {
      if(res){
        res.contents.forEach(obj=>{
          let aliasNames = obj.aliases?.map(alias=>alias.name);
          obj['aliasNames'] = aliasNames?.toString();
        })
        this.logger.info('Vertical List',res);
        this.verticalDataSource=res.contents;
        this.totalRecords=res.totalRecords;
      }
    })
  }

  private getStatusTypes(){
    this.service.get(Api.STATUS_TYPES_LIST).subscribe(res => {
      if(res){
        this.logger.info('Status List',res);
        this.statusTypes=res;
      }
    })
  }

  private getAllPermissions(){
    let permissionCodes=[PermissionKey.VERTICAL_MODULE_ADD_PERMISSION,PermissionKey.VERTICAL_MODULE_VIEW_PERMISSION];
    let permissionsWithShowValue:IPermissionWithShow[]=this.permissionService.checkPermissions(permissionCodes,PermissionKey.VERTICAL_MODULE);
    this.addPermission=_.findWhere(permissionsWithShowValue,{permissionCode:PermissionKey.VERTICAL_MODULE_ADD_PERMISSION})?.show?true:false;
    this.viewPermission=_.findWhere(permissionsWithShowValue,{permissionCode:PermissionKey.VERTICAL_MODULE_VIEW_PERMISSION})?.show?true:false;
    this.logger.info("Permissions with show",permissionsWithShowValue);
  }

  get name(){ return this.verticalListForm.get('name'); }
  get code(){ return this.verticalListForm.get('code'); }
  get status(){ return this.verticalListForm.get('status'); }
  get aliasName(){ return this.verticalListForm.get('aliasName'); }
}
